/* eslint-disable jsx-a11y/heading-has-content, react/no-array-index-key */
/* eslint-disable no-shadow */
import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ReactAux, Section, InfoCard } from '@jkhy/vsg-design-system';
import { Base, BaseType as BaseType_ } from '../common/base-component';
import { getEvaluatedQDModels } from '../../redux/actions/loan-application-actions';
import { getFinancialInstitutionDisclaimersAndFinePrint } from '../../redux/actions/setting-actions';
import { endLoading, startLoading } from '../../redux/actions/loading-actions';
import { AppState as AppState_ } from '../../redux/app-state';
import { healthCheck, HealthCheckModel as HealthCheckModel_ } from '../../redux/actions/health-check-actions';
import {
  GET_EVALUATED_QD_MODELS_FAIL,
  GET_EVALUATED_QD_MODELS_SUCCESS
} from '../../redux/actions/actionTypes/loan-applications';
import {
  GET_FINANCIAL_INSTITUTION_DISCLAIMERS_AND_FINE_PRINT_FAIL,
  GET_FINANCIAL_INSTITUTION_DISCLAIMERS_AND_FINE_PRINT_SUCCESS
} from '../../redux/actions/actionTypes/settings';
import { FETCHING_ENDED, FETCHING_STARTED } from '../../redux/actions/actionTypes/loading';
import QDApplicationModel_ from '../../data/models/QDApplicationModel';
import ResponseBase_ from '../../data/models/ResponseBase';
import { QDExternalModelByCustomerType } from '../../data/models/Enum';
import './tests/create-new-commercial-request-mock-data';
import PublicContent from '../../data/models/PublicContent';
import { AppDispatch } from '../../data/models/AppDispatch';
import { isNullOrWhiteSpace } from '../../utils/helper';
import '../../../css/default.css';

export const PageDataUI = 'CreateNewRequest';

type CreateNewRequestProps = {
  healthCheck: HealthCheckModel_,
  loanApplications: ResponseBase_<QDApplicationModel_[]>,
  disclaimersPrompt: string,
  getEvaluatedQDCommercialModels: () => Promise<typeof GET_EVALUATED_QD_MODELS_SUCCESS | typeof GET_EVALUATED_QD_MODELS_FAIL>,
  getFinancialInstitutionDisclaimersAndFinePrint: () => Promise<typeof GET_FINANCIAL_INSTITUTION_DISCLAIMERS_AND_FINE_PRINT_SUCCESS |
    typeof GET_FINANCIAL_INSTITUTION_DISCLAIMERS_AND_FINE_PRINT_FAIL>,
  startLoading: () => Promise<typeof FETCHING_STARTED>,
  endLoading: () => Promise<typeof FETCHING_ENDED>,
  healthCheckAction: () => Promise<{ payload: HealthCheckModel_ }>
} & BaseType_

class CreateNewCommercialRequest extends Base<CreateNewRequestProps, {}> {
  async componentDidMount() {
    const {
      getEvaluatedQDCommercialModels,
      getFinancialInstitutionDisclaimersAndFinePrint,
      startLoading,
      endLoading,
      healthCheckAction,
      disclaimersPrompt,
    } = this.props;

    startLoading();

    const { payload: { isChecked, status, }, } = await healthCheckAction();

    if (isChecked && status === 200) {
      await getEvaluatedQDCommercialModels();
    }

    if (!disclaimersPrompt) {
      await getFinancialInstitutionDisclaimersAndFinePrint();
    }
    endLoading();
  }

  content = () => {
    const { loanApplications, disclaimersPrompt, healthCheck, } = this.props;
    const mappedDisclaimersPrompt = disclaimersPrompt?.replaceAll('<p></p>', '<br>');

    if (healthCheck.isChecked && healthCheck.status !== 200) {
      return (
        <Section
          title="New Commercial Loan Application"
          dataUI={PageDataUI}
        >
          <p className="mb-3">{healthCheck.status}</p>
        </Section>
      );
    }

    const { externalApplicationPageTitle, externalApplicationPageDescription, } = window?.PublicContent ?? new PublicContent();
    return (
      <ReactAux>
        <Section dataUI={PageDataUI}>
          <h1 data-ui={`${PageDataUI}-page-title`} className="mb-2 text-preline break-word">{externalApplicationPageTitle}</h1>
          <p data-ui={`${PageDataUI}-page-description`} className="mb-3 text-preline break-word">{externalApplicationPageDescription}</p>

          {loanApplications?.result?.map((card: QDApplicationModel_, i: number) => {
            const { code, } = card;
            const onlineAppUrl = isNullOrWhiteSpace(window.onlineApplicationURL) ? window.quickDecisionV2URL : window.onlineApplicationURL;

            return (
              <InfoCard
                dataUI={`CreateNewRequestCard${i}`}
                key={code}
                className="mb-3"
                logo={card?.customerPortalImage}
                titles={[card?.customerPortalTitle]}
                description={card?.customerPortalDescription}
                link={{
                  label: 'APPLY NOW',
                  path: `${onlineAppUrl}/app/${code}/`,
                  isNativeLink: true,
                  isOpenNewTab: false,
                  dataUI: `CreateNewRequestCardLink${i}`,
                }}
              />
            );
          })}

          <div data-ui="disclaimer-prompt" className="break-word" dangerouslySetInnerHTML={{ __html: mappedDisclaimersPrompt, }} />
        </Section>
      </ReactAux>
    );
  }
}

export default withRouter(connect(
  (state: AppState_) => ({
    healthCheck: state.healthCheck,
    loanApplications: state.loanApplications,
    disclaimersPrompt: state.disclaimersPrompt,
  }),
  (dispatch: AppDispatch) => {
    return {
      startLoading: () => dispatch(startLoading()),
      endLoading: () => dispatch(endLoading()),
      getEvaluatedQDCommercialModels: () => dispatch(getEvaluatedQDModels(QDExternalModelByCustomerType.Commercial)),
      getFinancialInstitutionDisclaimersAndFinePrint: () => dispatch(getFinancialInstitutionDisclaimersAndFinePrint()),
      healthCheckAction: () => dispatch(healthCheck()),
    };
  }
)(CreateNewCommercialRequest));
